import { render, staticRenderFns } from "./inputer-select.vue?vue&type=template&id=6c80c482"
import script from "./inputer-select.vue?vue&type=script&lang=js"
export * from "./inputer-select.vue?vue&type=script&lang=js"
import style0 from "./inputer-select.vue?vue&type=style&index=0&id=6c80c482&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports